// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import LittleEllyPage from './pages/LittleEllyPage/LittleEllyPage';
import AboutPage from './pages/AboutPage/AboutPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import DeepawaliCarnivalPage from './pages/DeepawaliCarnivalPage/DeepawaliCarnivalPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import AdminPage from './pages/AdminPage/AdminPage';
import StallOwnerRegPage from './pages/StallOwnerRegPage/StallOwnerRegPage';
import AdmissionFormPage from './pages/AdmissionFormPage/AdmissionFormPage';
import SummerCampPage from './pages/SummerCampPage/SummerCampPage';
import './styles/global.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/schools/little-elly-kudlu" element={<LittleEllyPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                <Route path="/deepawalicarnival" element={<DeepawaliCarnivalPage />} />
                <Route path="/deepawalicarnival/register" element={<RegisterPage />} />
                <Route path="/deepawalicarnivaladmin" element={<AdminPage />} />
                <Route path="/luckystalls" element={<StallOwnerRegPage />} />
                <Route path="/admissions" element={<AdmissionFormPage />} />
                <Route path="/summercamp" element={<SummerCampPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
}

export default App;